import { BillingCategory, enumController } from '../core';
import { SelectItem } from '@/utils/types';
import { snakeToTitleCase } from '@/utils';

const compare = (a: SelectItem, b: SelectItem) =>
  a.label.localeCompare(b.label);

export const getBillingCategoryOptions = async () => {
  const categories: BillingCategory[] =
    await enumController.getBillingCategories();
  return categories.map((category) => ({
    label: snakeToTitleCase(category.name),
    value: category.id,
  }));
};

export const getRejectionCategoryOptions = async (): Promise<SelectItem[]> => {
  const response = await enumController.getRejectionCategories();
  return response.map((category) => ({
    label: category.name,
    value: category.id,
  }));
};

export const getSmsUseCaseOptions = async () => {
  const useCases = await enumController.getUseCases({
    channelId: 'SMS',
  });
  return useCases.map((useCase) => ({
    label: useCase.displayName,
    value: useCase.id,
  }));
};

export const getTenDlcUseCaseOptions = async () => {
  const useCases = await enumController.getUseCases({
    channelId: '10DLC', // default is '10DLC'
  });
  return useCases.map((useCase) => ({
    label: useCase.displayName,
    value: useCase.id,
  }));
};

export const getRcsUseCaseOptions = async () => {
  const useCases = await enumController.getUseCases({
    channelId: 'RCS',
  });
  return useCases.map((useCase) => ({
    label: useCase.displayName,
    value: useCase.id,
  }));
};

export const getVerificationStatusOptions = async () => {
  const statuses = await enumController.getCampaignVerificationStatus();
  return statuses.map((status) => ({
    label: status.charAt(0) + status.slice(1).toLowerCase(),
    value: status,
  }));
};

export const getAttestationStatusOptions = async () => {
  const statuses = await enumController.getAttestationStatus();
  return statuses.map((status) => ({
    label: status.charAt(0) + status.slice(1).toLowerCase(),
    value: status,
  }));
};

export const getCountryOptions = async () => {
  const countries = await enumController.getCountries();
  return Object.entries(countries)
    .map(([key, label]) => ({ label, value: key }))
    .sort(compare) as SelectItem[];
};

export const getUsStateOptions = async (): Promise<SelectItem[]> => {
  const states = await enumController.getUsStates();
  return Object.entries(states).map(([key, value]) => ({
    label: value,
    value: key,
  }));
};

export const getStockExchangeOptions = async (): Promise<SelectItem[]> => {
  const exchanges = await enumController.getStockExchanges();
  return exchanges.map((exchange) => ({
    label: exchange,
    value: exchange,
  }));
};
